

import styled from "styled-components"
import InputPlacesForKmHesaplama from "../shared/customInput/InputPlacesForKmHesaplama"
import Btn from "../shared/button/Btn"
import { useDispatch, useSelector } from "react-redux"
import { addRoutePoint, clearRouteItemLocation, deleteRouteItem, updateAllRoute } from "../../features/kmCalc/kmCalcSlice"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { MdOutlineDragIndicator, MdOutlineLocationOn } from "react-icons/md";
import { useEffect, useState } from "react"

const Container = styled.div`
    height: 100vh;
    width: 460px;
    border-right: 1px solid ${({theme}) => theme.mainTextColor};
    position: relative;

    .top-container{
      width: 100%;
      margin: 30px 0;
      padding-left: 20px;

      h1{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-xl);
      }
    }

    .route-container{
        padding: 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 40px;
        height: calc(100vh - 260px);
        overflow: auto;
        border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

        &::-webkit-scrollbar {
            width: 0;
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .drag-container{
          display: flex;
          flex-direction: column;
          gap: 30px;
        }

        .route-item{
          display: flex;
          flex-direction: column;
          gap: 5px;

          .route-item-top{
            display: flex;
            justify-content: space-between;
            margin-left: 30px;
          
            .route-number{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
              padding-left: 10px;
            }

            .route-top-controller{
              display: flex;
              align-items: center;
              gap: 10px;
              
              .control-btn{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                color: var(--color-main);
                cursor: pointer;
              }
            }
          }


          .grp{
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
              border: 1px solid ${({theme}) => theme.mainBorderColor};
              border-radius: 10px;
              padding: 15px 5px;

              .icon{
                font-size: 1.2rem;
              }
            }
        }


        .km-result-container{
          background-color: var(--color-main);
          color: #fff;
          padding: 20px;
          border-radius: 10px;
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          display: flex;
          justify-content: center;
        }
    }

    .control-container{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      margin-top: 40px;
      padding: 20px;

      .km-result-container{
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTextColor};
      }
    }

    @media (max-width: 1450px) {
      width: 350px;
    }

    @media (max-width: 1100px) {
      border: none;
      width: 100%;
  }

`
const KmHesaplamaRouteSide = () => {

  const dispatch = useDispatch()
  const {route, kmData} = useSelector(state => state.kmCalc)

  const handleAddRoute = () => {
    dispatch(addRoutePoint())
  }

  const onDragEnd = (result) => {
    if (!result.destination) return; // Sürükleme hedefi yoksa

    const reorderedItems = Array.from(route);
    const [movedItem] = reorderedItems.splice(result.source.index, 1); // Öğeyi kaydır
    reorderedItems.splice(result.destination.index, 0, movedItem);

    dispatch(updateAllRoute(reorderedItems))
    
  };
  
  return (
    <Container>
    <div className="top-container">
        <h1>Km Hesaplama</h1>
    </div>

    <div className="route-container">
    <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="route-container">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef} className="drag-container">
                    {
                        route.map((item, i) => (
                          <Draggable key={item.id} draggableId={item.id} index={i} >
                          {(provided) => (
                            <div className="route-item" 
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}>
                            <div className="route-item-top">
                              <div className="route-number">{`${i+1}. Rota Noktası`}</div>
                              <div className="route-top-controller">
                                  {
                                    item?.location &&
                                    <div className="control-btn" onClick={() => dispatch(clearRouteItemLocation(item?.id))}>Temizle</div>
                                  }
                                  {
                                    route.length > 2 &&
                                    <div className="control-btn" onClick={() => dispatch(deleteRouteItem(item?.id))}>Kaldır</div>
                                  }
                              </div>
                            </div>
                            <div className="grp">
                              <MdOutlineLocationOn className="icon"/>
                              <InputPlacesForKmHesaplama name={"kmHesaplamaPlaces"+i} routeItem={item} inputWidth={"85%"} labelText={"Adres"}/>
                              <MdOutlineDragIndicator className="icon"/>
                            </div>
                          </div>
                          )}
                        </Draggable>
                        ))
                    }
                  </div>
                )}
              </Droppable>
            </DragDropContext>
    </div>

    <div className="control-container">
      <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={handleAddRoute}>Rota Noktası Ekle</Btn>
      {
        kmData && 
        <div className="km-result-container">
          Toplam Kilometre : {kmData} Km
        </div>
      }
    </div>
    </Container>
  )
}

export default KmHesaplamaRouteSide